type ConditionalWrapperProps = {
  condition: boolean;
  wrapper: any;
  OrWrapper?: any;
  children: any;
};

export const ConditionalWrapper = ({ condition, wrapper, OrWrapper, children }: ConditionalWrapperProps) =>
  condition ? wrapper(children) : OrWrapper ? OrWrapper(children) : children;
